// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'

import dataStructure from '../validation/dataStructure'

Vue.use(Vuex);
Vue.use(VueResource);

//TODO: After user authentication, add stuff here
const store = new Vuex.Store({

  state: {
    userId: null,
    userAuthToken: null, // Authentication status depends on whether userAuthToken is null or not. If not null, then display stuff
    userEmail: null,
    coachingLessonsAll: [],
    coachingActionsAll: [],
    patientsAllOverview: [],
    coachingActionPlansAll: [],
    coachingLessonPlansAll: [],
    userIdToMedgateId: {}
  },
  getters: {
    sortedLessonPlan: function(state) {
      //TODO: Sort lesson plan by lastmodifiedtime or something

    },
    sortedActionPlan: function(state) {
      //TODO: Sort action plan by lastmodifiedtime or something

    },
    sortedPatients: function(state) {
      //TODO: Sort patients by medgate id?

    }
  },
  mutations: {
    setUserProfile: (state, payload) => {
      state.userId = payload.userId;
      state.userAuthToken = payload.userAuthToken;
      state.userEmail = payload.userEmail;
    },
    setCoachingLessonsAll: (state, payload) => {

      let lessonStructure = dataStructure.lessonStructure;

      let coachingLessonsAll = payload.coachingLessonsAll.map((element) =>
        Object.assign({}, lessonStructure, element));

      state.coachingLessonsAll = coachingLessonsAll;
    },
    setCoachingActionsAll: (state, payload) => {

      let actionStructure = dataStructure.actionStructure;

      let coachingActionsAll = payload.coachingActionsAll.map((element) =>
        Object.assign({}, actionStructure, element));

      state.coachingActionsAll = coachingActionsAll;
    },
    setCoachingActionPlansAll: (state, payload) => {

      let actionPlanStructure = dataStructure.actionPlanStructure;

      let coachingActionPlansAll = payload.coachingActionPlansAll.map((element) =>
        Object.assign({}, actionPlanStructure, element));
      state.coachingActionPlansAll = coachingActionPlansAll;
    },
    setCoachingLessonPlansAll: (state, payload) => {

      let lessonPlanStructure = dataStructure.lessonPlanStructure;

      let coachingLessonPlansAll = payload.coachingLessonPlansAll.map((element) =>
        Object.assign({}, lessonPlanStructure, element));
      state.coachingLessonPlansAll = coachingLessonPlansAll;
    },
    setPatientsAllOverview: (state, payload) => {
      // TODO: Validator Object for patient.data
      // TODO: Validator Object for patient.userPlans

      let patientStructure = dataStructure.patientStructure;

      let patientsAllOverview = payload.patientsAllOverview.map( function(element){

        let patientProfile = element.userPlans.find((element) => element.planType==='profile');

        //FIXME: Not sure if we should be cloning in patients that have null data
        if (element.data === null || Object.keys(element.data).length === 0) {
          element.profile = Object.assign({}, dataStructure.profilePlanStructure, patientProfile);
          element.data = Object.assign({}, element.data, patientStructure.data);
          return element
        }
        else {
          //this clones over any keys that are missing from element.data
          element.profile = Object.assign({}, dataStructure.profilePlanStructure, patientProfile);
          element.data = Object.assign({}, patientStructure.data, element.data);

          //This adds an MBuserid: programId mapping ONLY for users who have accounts
          state.userIdToMedgateId[element.userId] = {
            medgateId: element.profile.data.medgateId,
            programUserId: element.id,
            mbUserId: element.userId
          };

          return element
        }
      });

      state.patientsAllOverview = patientsAllOverview;
    },
    addNewLesson: (state, payload) => {
      state.coachingLessonsAll.push(payload);
    },
    addNewAction: (state, payload) => {
      state.coachingActionsAll.push(payload);
    },
    addNewPatient: (state, payload) => {
      state.patientsAllOverview.push(payload);
    },
    addNewLessonPlan: (state, payload) => {
      state.coachingLessonPlansAll.push(payload);
    },
    addNewActionPlan: (state, payload) => {
      state.coachingActionPlansAll.push(payload);
    },
    // FIXME: Add corresponding store action so that we can make sure it's successfully removed THEN push edited version
    removeSelectedLesson: (state, id) => {
      let index = state.coachingLessonsAll.findIndex((lesson) => lesson.id === id);
      state.coachingLessonsAll.splice(index, 1);
    },
    // FIXME: Add corresponding store action so that we can make sure it's successfully removed THEN push edited version
    removeSelectedAction: (state, id) => {
      let index = state.coachingActionsAll.findIndex((action) => action.id === id);
      state.coachingActionsAll.splice(index, 1);
    },
    unsetStore: (state) => {
      state.userId = null;
      state.userAuthToken = null;
      state.userEmail = null;
      state.patientsAllOverview = [];
      state.coachingActionsAll = [];
      state.coachingLessonsAll = [];
      state.coachingActionPlansAll = [];
      state.coachingLessonPlansAll = [];
    }
  },
  actions: {
    updateUserProfile( { commit } , payload) {
      return new Promise((resolve, reject) => {
        commit('setUserProfile', payload);
        resolve();
      })
    },
    updateCoachingActionsLessonsAll( { commit } , payload) {
      return new Promise((resolve, reject) => {
        commit('setCoachingLessonsAll', payload);
        commit('setCoachingActionsAll', payload);
        resolve();
      })
    },
    updateCoachingPlansAll( { commit } , payload) {
      return new Promise((resolve, reject) => {
        commit('setCoachingActionPlansAll', payload);
        commit('setCoachingLessonPlansAll', payload);
        resolve();
      })
    },
    updatePatientsAllOverview( { commit } , payload) {
      return new Promise((resolve, reject) => {
        commit('setPatientsAllOverview', payload);
        resolve();
      })
    },
  }
})


export default store



// WEBPACK FOOTER //
// ./src/store/store.js